import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useChatConfig } from '@/ui/ChatProvider';
/** The brand inside `copy.poweredBy` that becomes the link. */
const BRAND = 'AgenticXLab';
/**
 * "Powered by AgenticXLab" under the composer. With `copy.poweredByUrl` the
 * brand is a link in the widget's theme colour, opening in a new tab and tagged
 * so the site's analytics can tell which page it came from. A host's own text
 * without the brand links as a whole; `poweredByUrl: ''` keeps it plain text.
 */
export function PoweredBy() {
    const { copy } = useChatConfig();
    const text = copy.poweredBy;
    if (!text)
        return null;
    const href = copy.poweredByUrl ? withCampaign(copy.poweredByUrl) : '';
    if (!href)
        return _jsx("div", { className: "ac-footer", children: text });
    const link = (label) => (_jsx("a", { className: "ac-footer-link", href: href, target: "_blank", rel: "noopener", children: label }));
    const at = text.indexOf(BRAND);
    return (_jsx("div", { className: "ac-footer", children: at < 0 ? (link(text)) : (_jsxs(_Fragment, { children: [text.slice(0, at), link(BRAND), text.slice(at + BRAND.length)] })) }));
}
/** UTM tags: source = the widget, content = the site it is on. Existing tags win. */
function withCampaign(url) {
    try {
        const u = new URL(url);
        const tags = {
            utm_source: 'chat_widget',
            utm_medium: 'referral',
            utm_campaign: 'powered_by',
            utm_content: typeof location !== 'undefined' ? location.hostname : '',
        };
        for (const [key, value] of Object.entries(tags)) {
            if (value && !u.searchParams.has(key))
                u.searchParams.set(key, value);
        }
        return u.toString();
    }
    catch {
        return '';
    }
}
